module.exports = __webpack_public_path__ + "assets/premium.56c2f86c.svg";